import Config from "./../../config";
// export const google = Config.google_properties;
//todo update redirect_uri while sharing coa build
// export const server = Config.server_properties;
export const cookieKeys = Config.cookieKeys;
export const googleProperties = Config.google_properties;